export default __webpack_public_path__ + "static/splunks-301ced20216a15c8a4d203c81d6e510c.jpg";